RivalIQ.apps.AccountSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.InvoiceSettings = RivalIQ.views.ItemView.extend({
        template: '#accountInvoiceSettingsTemplate',
        ui: {
            saveBtn: '.x-save'
        },

        events: {
            'click @ui.saveBtn': 'saveChanges'
        },

        behaviors: {
            FormValidator: {
                bindModel: false
            }
        },

        serializeData: function () {
            const me = this;
            return _.defaults(me.model.get('settings'), {
                invoiceSettings: {}
            });
        },

        saveChanges: function () {
            const me = this;

            me.ui.saveBtn.button('Loading');
            me.triggerMethod('resetValidationErrors');

            const result = me.model.patchSettings(me.formAttrs);

            if (!result) {
                return me.ui.saveBtn.button('reset');
            }

            result
                .done(function () {
                    RivalIQ.execute('alert:info', 'Invoice Settings Saved');
                    RivalIQ.execute('hide:modal');
                })
                .fail(function (xhr) {
                    me.ui.saveBtn.button('reset');

                    if (xhr.errorName === 'BadEmailAddressError') {
                        return me.triggerMethod('display:error', 'invoiceSettings[billingEmail]', 'Invalid Email');
                    }

                    RivalIQ.execute('alert:danger', 'An error occurred submitting your request. Please try again');
                });
        },

        serializeSettings: function () {
            return {
                invoiceSettings: {
                    companyName: this.$('[name=companyName]').val(),
                    addressLine1: this.$('[name=addressLine1]').val(),
                    addressLine2: this.$('[name=addressLine2]').val(),
                    phoneNumber: this.$('[name=phoneNumber]').val(),
                    vatNumber: this.$('[name=vatNumber]').val(),
                    billingEmail: this.$('[name=billingEmail]').val()
                }
            };
        },

        onShow: function () {
            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.ViewedReceiptsSettings);
        }
    });
});
